import { Action, createAction, props } from '@ngrx/store'
import {
  CustomValuesEntity,
  ProfileEntity,
  NotificationSettingsPayload,
  CompleteProfilePayload,
} from './selected-profile.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'
import { AccountDetailsFormConfig } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'

export const updateSelectedProfile = createAction(
  '[SelectedProfile/API] Update Selected Profile',
  props<{
    profile: CompleteProfilePayload
    showSnackBar: boolean
    snackBarMessage?: string
    shouldRedirect: boolean
    dialog: boolean
  }>(),
)

export const updateSelectedProfileSuccess = createAction(
  '[SelectedProfile/API] Update Selected Profile Success',
  props<{
    profile: ProfileEntity
    showSnackBar: boolean
    snackBarMessage?: string
    dialog: boolean
    shouldRedirect: boolean
  }>(),
)

export const updateSelectedProfileFailure = createAction(
  '[SelectedProfile/API] Update Selected Profile Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const setCompleteProfilePrompted = createAction('[SelectedProfile/API] Set Complete Profile Prompted')

export const setCompleteProfilePromptedSuccess = createAction(
  '[SelectedProfile/API] Set Complete Profile Prompted Success',
  props<{ profile: ProfileEntity }>(),
)

export const setSelectedProfile = createAction(
  '[SelectedProfile Page] Set Selected Profile',
  props<{ uuid: string; onSelectProfileActions?: Action[] }>(),
)

export const syncProfile = createAction(
  '[SelectedProfile/API] Sync Profile',
  props<{
    showLoader?: boolean
    showSnackBarOnFail?: boolean
    checkProfile?: boolean
    onSuccess?: () => Action
  }>(),
)

export const syncProfileSuccess = createAction(
  '[SelectedProfile/API] Sync Profile Success',
  props<{ profile: ProfileEntity }>(),
)

export const syncProfileFailure = createAction(
  '[SelectedProfile/API] Sync Profile Error',
  props<{ error: HttpErrorResponse; showSnackBar?: boolean }>(),
)

export const setGuestProfile = createAction(
  '[SelectedProfile/API] Set Guest Profile',
  props<{ profile: ProfileEntity }>(),
)

export const checkProfile = createAction('[SelectedProfile Page] Check Profile', (onSuccess?: () => Action) => ({
  onSuccess,
}))

export const openCheckProfileDialog = createAction(
  '[Profiles] Open Check Profile Dialog',
  (onSuccess?: () => Action, formConfig?: AccountDetailsFormConfig) => ({ onSuccess, formConfig }),
)

export const clearSelectedProfile = createAction('[SelectedProfile Page] Clear Selected Profile')

export const clearSelectedProfileFieldsVolunteer = createAction(
  '[SelectedProfile Page] Clear Selected Profile Fields Volunteer',
)

// custom values
export const createCustomValue = createAction(
  '[Profiles/API] Create custom value',
  props<{ customFieldUuid: string; value: string }>(),
)

export const createCustomValueSuccess = createAction(
  '[Profiles/API] Create custom value success',
  props<{ customValue: CustomValuesEntity }>(),
)

export const createCustomValueFailure = createAction(
  '[Profiles/API] Create custom value Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateCustomValue = createAction(
  '[Profiles/API] Update custom value',
  props<{ update: Update<CustomValuesEntity> }>(),
)

export const updateCustomValueSuccess = createAction(
  '[Profiles/API] Update custom value success',
  props<{ customValue: CustomValuesEntity }>(),
)

export const updateCustomValueFailure = createAction(
  '[Profiles/API] Update custom value Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateProfileNotificationSettings = createAction(
  '[Profiles/Page] Update Profile Notification Settings',
  props<{ payload: NotificationSettingsPayload }>(),
)
